import { greens, reds } from '../../base/colors';

const icons = {
  wishlist: reds.red500,
  checkIconColor: greens.green500,
};

export default icons;
